import { Box, HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { Validation } from '@m/icons';

export const SectionHeader = ({
  children,
  dataTestId,
  title,
  padding = 4,
}: {
  children?: React.ReactNode;
  dataTestId?: string;
  padding?: number;
  title: React.ReactNode;
}) => (
  <Stack py={padding} gap={2} data-testid={dataTestId}>
    <Text as="span" variant="Subheader" fontWeight="600" color="text.primary">
      {title}
    </Text>
    {children && (
      <Text as="span" variant="SmallBody" color="text.secondary">
        {children}
      </Text>
    )}
  </Stack>
);

export const ListRow = ({
  icon,
  title,
  children,
  rightContent,
}: {
  children: React.ReactNode;
  icon?: React.ReactNode;
  rightContent?: React.ReactNode;
  title: React.ReactNode;
}) => (
  <HStack py={4} gap={4}>
    <Box fontSize="20px" color="fill.icon.descriptive">
      {icon}
    </Box>
    <Stack>
      <Text variant="MainBody" fontWeight="500" color="text.primary">
        {title}
      </Text>
      <Text variant="MainBody" color="text.secondary">
        {children}
      </Text>
    </Stack>
    {rightContent && <Box ml="auto">{rightContent}</Box>}
  </HStack>
);

export const CostRow = ({
  amount,
  dataTestId,
  description,
  icon,
  info,
  isValidation,
  isTotal,
  priceDetails,
  title,
}: {
  amount: React.ReactNode;
  dataTestId?: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  info?: React.ReactNode;
  isTotal?: boolean;
  isValidation?: boolean;
  priceDetails?: React.ReactNode;
  title: React.ReactNode;
}) => (
  <Stack gap={1} py={2} data-testid={dataTestId}>
    <HStack justifyContent="space-between" color="text.primary">
      <HStack gap={1}>
        {isValidation ? <Icon as={Validation} color="fill.icon.green" /> : icon}
        <Text as="span" variant="MainBody" fontWeight={isTotal ? '600' : '400'}>
          {title}
        </Text>
        {info}
      </HStack>
      <Text as="span" variant="MainBody" fontWeight={isTotal ? '600' : '400'}>
        {amount}
      </Text>
    </HStack>
    {(description || priceDetails) && (
      <HStack justifyContent="space-between" color="text.secondary">
        <Text as="span" variant="SmallBody">
          {description}
        </Text>
        <Text as="span" variant="SmallBody">
          {priceDetails}
        </Text>
      </HStack>
    )}
  </Stack>
);

export const Note = ({ children }: { children: React.ReactNode }) => (
  <Text py={2} variant="SmallBody" color="text.secondary">
    {children}
  </Text>
);
